import MosaicList from 'core/modules/components/lists/components/MosaicList/MosaicList';
import ClassroomsSimpleItem from 'core/modules/components/lists/classrooms-simple/ClassroomsSimpleItem/ClassroomsSimpleItem';
import React from 'react';

/**
 * ClassroomsSimpleList - Mosaico simple de aulas. Envuelve el genérico v2 `MosaicList`
 * (semántica `<ul>/<li>` accesible) y renderiza un `ClassroomsSimpleItem` por aula.
 */

// `ClassroomsSimpleItem` es JS (props sin tipar): se aliasa a un componente permisivo
// para poder inyectar las props de dominio de cada aula mediante spread.
const ClassroomItem = ClassroomsSimpleItem as unknown as React.FC<Record<string, unknown>>;

export type Classroom = Readonly<{ guid?: string }> & Record<string, unknown>;

type ClassroomsSimpleListProps = Readonly<{
  classrooms?: Classroom[];
  columns?: number;
  onDelete?: (code: unknown) => void;
}>;

function ClassroomsSimpleList({ classrooms = [], columns = 2, onDelete }: ClassroomsSimpleListProps): JSX.Element {
  return (
    <div>
      <MosaicList
        // Deuda técnica conocida (TAN-8613): algunos consumidores pasan `columns={1}`,
        // que `MosaicList` no tipa (solo 2|3|4). Se preserva el comportamiento actual.
        columns={columns as 2 | 3 | 4}
        items={classrooms.map((item, index) => (
          <ClassroomItem key={item.guid ?? index} {...item} onDelete={onDelete} />
        ))}
      />
    </div>
  );
}

export default ClassroomsSimpleList;
